import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import { Button, ButtonGroup, Card, CardBody, CardHeader, Col, Container, Label, Row, Spinner, Table } from "@/Components/ui";;
import { API_SITES_USERVISIT, BACKEND_HOST, getDataFromUrl } from "../../../api";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import TicketSalesDetail from "./TicketSalesDetail";
import Widgets from "../../../Components/Common/Widgets";
import CommonDatePicker from "@/Components/Common/CommonDatePicker";
import BalanceOverview from "./BalanceOverview";
import { read, utils, writeFileXLSX, writeFile } from "xlsx";
import PackageSalesDetail from "./PackageSalesDetail";
import Select from "react-select";
import { mergeSiteStatistics } from "./statisticsUtils";

function weekCount(year, month_number, day_num = 0) {
  // month_number is in the range 0..11
  const firstOfMonth = moment().year(year).month(month_number);
  const lastOfMonth = moment().year(year).endOf("month");
  let lastday = lastOfMonth.date();
  if (day_num > 0) lastday = day_num;
  const used = firstOfMonth.day() + lastday;
  return Math.ceil(used / 7);
}

function openWindowWithTable(datas) {
  var a = window.open("", "", "height=1024, width=768");
  a.document.write("<html>");
  a.document.write('<body><table class="custom-header-css table" style="border: 1px solid black; border-collapse: collapse; border-spacing: 0;">');
  a.document.write('<thead className="table-light text-muted"><tr>');
  for (const tableColumn in datas[0]) {
    if (Object.hasOwnProperty.call(datas[0], tableColumn)) {
      // const element = datas[0][tableColumn];
      a.document.write(`<th style="border: 1px solid black;">${tableColumn}</th>`);
    }
  }
  a.document.write("</tr></thead>");

  a.document.write('<tbody className="table-light text-muted">');
  for (let i = 0; i < datas.length; i++) {
    const data = datas[i];
    a.document.write("<tr>");
    for (const tableColumn in data) {
      if (Object.hasOwnProperty.call(data, tableColumn)) {
        const element = data[tableColumn];
        a.document.write(`<td style="border: 1px solid black;">${element}</td>`);
      }
    }
    a.document.write("</tr>");
  }
  a.document.write("</tbody>");

  a.document.write("</table></body></html>");
  a.document.close();
}


// function export_ticket_data(data) {
//     return data
//         // .sort((a, b) => (moment(a["사용일"]) > moment(b["사용일"]) ? 1 : -1))
//         .map(item => {
//             return {
//                 // "id": item["id"],
//                 "고객명": item["이름"],
//                 "전화번호": item["고객"],
//                 "상품": item["상품"],
//                 "상태": item["상태"],
//                 "사용일": item["사용일"] !== "-" ? moment(item["사용일"]).format('YYYY-MM-DD') : "",
//                 // "만료일": item["만료일"],
//                 "선물상태": item["gifted"],
//                 "가격": item["가격"],
//                 // "총액": sum_total,
//                 "수수료": Math.round(item["가격"] * 0.1)
//             }
//         })
// }

function export_receipt_data(data) {
  return (
    data
      // .sort((a, b) => (moment(a["사용일"]) > moment(b["사용일"]) ? 1 : -1))
      .map((item) => {
        return {
          order_id: item["order_id"],
          분류: item["type"],
          결재일: moment(item["order_date"]).format("YYYY-MM-DD HH:mm:ss"),
          취소일: item["cancel_date"] ? moment(item["cancel_date"]).format("YYYY-MM-DD") : "",
          고객: item["username"] + "(" + item["phone_num"] + ")",
          // "phone_num": item["phone_num"],
          상품명: item["name"],
          상세정보: item["info"],
          key: item["payments_key"].slice(0, 5) + "..",
          // "주문총금액": item["order_amount"],
          // "old": item["_amount"],
          금액: item["amount"],
        };
      })
  );
}

const SalesStatistics = () => {
  document.title = "Statistics";

  const [startDate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));

  const [siteStatistics, setSiteStatistics] = useState([]);

  const [siteStatistic, setSiteStatistic] = useState({
    id: 84,
    site: 9,
    date: "2023-01-07",
    total_amount: 0,
    statestics_option_products: [
      {
        name: "",
        order_count: 0,
        order_total: 0,
        canceled_count: 0,
        canceled_total: 0,
      },
    ],
    statestics_pacakge_products: [
      {
        name: "",
        order_count: 0,
        order_total: 0,
        canceled_count: 0,
        canceled_total: 0,
      },
    ],
    statestics_ticket_products: [
      {
        name: "",
        order_count: 0,
        order_total: 0,
        canceled_count: 0,
        canceled_total: 0,
      },
    ],
    total_amount_info: {
      total_reserv: 0,
      total_reserv_option: 0,
      total_ticket: 0,
      total_cancel_reserv: 0,
      total_cancel_reserv_option: 0,
      total_cancel_ticket: 0,
    },
  });

  const [siteInfo, setSiteInfo] = useState(null);
  const [userVisitData, setUserVisitData] = useState([]);
  const [loadingUserVisit, setLoadingUserVisit] = useState(false);
  const [loadingStatistic, setLoadingStatistic] = useState(false);
  const [loadingReceipt, setLoadingReceipt] = useState(false);

  React.useEffect(() => {
    const today = moment();

    const dataPeriod = 7;
    // const weekBefore = today.subtract(dataPeriod, "days");
    // console.log(today, weekBefore);
    // console.log(weekBefore.format("YYYY-MM-DD"));

    const firstDayOfYear = moment().startOf("year");

    getDataFromUrl(`${BACKEND_HOST}/sites/statistic/?start_date=${firstDayOfYear.format("YYYY-MM-DD")}`)
      .then((data) => {
        // console.log("/sites/statistic/", data)
        setSiteStatistics(data);
        setSiteStatistic(data[data.length - 1]);
      })
      .catch((e) => {
        console.warn(e);
      });

    setLoadingUserVisit(true);
    getDataFromUrl(API_SITES_USERVISIT).then((data) => {
      console.log("user visit date:", data);
      if (data.result) {
        setUserVisitData(data.result);
        setLoadingUserVisit(false);
      }
    });
  }, []);

  useEffect(() => {
    if (siteStatistic) {
      getDataFromUrl(`${BACKEND_HOST}/sites/camps/${siteStatistic.site}`)
        .then((data) => {
          // console.log("/sites/camps/", data);
          // const campsite = data.find((item) => item.id === siteStatistic.site)
          // setSiteInfo(campsite)
          setSiteInfo(data);
        })
        .catch((e) => {
          console.warn(e);
        });
    }
  }, [siteStatistic]);

  const handlePickStatistic = (value, options = { syncGraph: false }) => {
    setLoadingStatistic(true);

    const start_date = moment(value[0]).format("YYYY-MM-DD");
    const end_date = moment(value[1]).format("YYYY-MM-DD");

    setStartDate(start_date);
    setEndDate(end_date);

    getDataFromUrl(`${BACKEND_HOST}/sites/statistic/?start_date=${start_date}&end_date=${end_date}`)
      .then((data) => {
        // console.log("handlePickStatistic", data)
        if (data.length) {
          setSiteStatistic(mergeSiteStatistics(data));
          if (options.syncGraph) setSiteStatistics(data);
        }
      })
      .catch((e) => {
        console.warn(e);
      })
      .finally(() => {
        setLoadingStatistic(false);
      });
  };

  const getGraphStatistics = (value) => {
    handlePickStatistic(value, { syncGraph: true });
  };

  const [termType, setTermType] = useState("day"); // day, week, month
  const [selectYear, setSelectYear] = useState(moment().year());
  const [selectMonth, setSelectMonth] = useState(moment().month());
  const [selectDay, setSelectDay] = useState(moment().date());
  const [selectWeek, setSelectWeek] = useState(weekCount(moment().year(), moment().month(), moment().date()) + 1);

  // const selectYearRange = [
  //     { label: "2022년", value: 2022 },
  //     { label: "2023년", value: 2023 },
  // ]
  const selectYearRange = Array.from(new Array(moment().year() - 2021), (val, index) => 2022 + index).map((val) => ({ label: val + "년", value: val }));

  const selectMonthRange = useMemo(() => {
    let month_num = 12;
    if (selectYear === moment().year()) month_num = moment().month() + 1;
    const _range = new Array(month_num).fill({}).map((_, idx) => ({ label: idx + 1 + "월", value: idx }));
    return _range;
  }, [selectYear]);
  // const selectDayRange = useMemo(() => {
  //     let day_num = moment().year(selectYear).month(selectMonth).endOf("month")
  //     if (selectYear === moment().year() && selectMonth === moment().month()) day_num = moment().date() + 1
  //     const _range = new Array(day_num).fill({}).map((_, idx) => ({ label: (idx + 1) + "일", value: idx + 1 }))
  //     return _range
  // }, [selectYear, selectMonth])
  // const selectWeekRange = useMemo(() => {
  //     let week_num = weekCount(moment().year(), moment().month())
  //     if (selectYear === moment().year() && selectMonth === moment().month()) week_num = weekCount(moment().year(), moment().month(), moment().date())
  //     const _range = new Array(week_num).fill({}).map((_, idx) => ({ label: (idx + 1) + "번째주", value: idx + 1 }))
  //     return _range
  // }, [selectYear, selectMonth])

  const selectDailyDate = (date) => {
    if (!date) return;
    const nextDate = moment(date);
    setSelectYear(nextDate.year());
    setSelectMonth(nextDate.month());
    setSelectDay(nextDate.date());
  };

  const moveSelectedDay = (amount) => {
    selectDailyDate(moment(startDate).add(amount, "day"));
  };

  useEffect(() => {
    let _start_date = moment().year(selectYear).month(selectMonth).date(1);
    let _end_date = moment().year(selectYear).month(selectMonth).endOf("month");
    if (termType === "day") {
      _start_date = moment().year(selectYear).month(selectMonth).date(selectDay);
      _end_date = moment().year(selectYear).month(selectMonth).date(selectDay);
    } else if (termType === "week") {
      let target_date = moment()
        .year(selectYear)
        .month(selectMonth)
        .date(_start_date.date() + (selectWeek - 1) * 7);
      console.log(target_date.format("YYYY-MM-DD"));
      _start_date = moment()
        .year(selectYear)
        .month(selectMonth)
        .date(target_date.date() - target_date.day());
      _end_date = moment()
        .year(selectYear)
        .month(selectMonth)
        .date(target_date.date() - target_date.day() + 6);
      // _start_date = target_date.startOf('week')
      // _end_date = target_date.endOf('week')
    }

    // console.log("change date here", _start_date.format('YYYY-MM-DD'), _end_date.format('YYYY-MM-DD'))
    handlePickStatistic([_start_date.toDate(), _end_date.toDate()], { syncGraph: true });
  }, [termType, selectYear, selectMonth, selectDay, selectWeek]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="매출 통계" pageTitle="통계" />
          {siteStatistics ? (
            <>
              <Row>
                <Widgets
                  data={[
                    {
                      id: 1,
                      label: "캠핑장",
                      // badge: "ri-arrow-up-circle-line text-success",
                      // icon: "ri-space-ship-line",
                      value: siteInfo ? siteInfo.name : "",
                    },
                    {
                      id: 2,
                      label: "날짜",
                      // badge: "ri-arrow-up-circle-line text-success",
                      // icon: "ri-space-ship-line",
                      value: (() => {
                        return (
                          <div>
                            <ButtonGroup className="me-2 mb-2" style={{ border: "none" }}>
                              <Button
                                color="primary"
                                onClick={() => setTermType("month")}
                                style={{
                                  backgroundColor: termType !== "month" ? "#82b1ff" : "#1c71ff",
                                  border: "none",
                                }}
                              // disabled={termType === "month"}
                              >
                                월간
                              </Button>
                              {/* <Button color="primary" onClick={() => setTermType("week")} disabled={termType === "week"}>주간</Button> */}
                              <Button
                                color="primary"
                                onClick={() => setTermType("day")}
                                style={{
                                  backgroundColor: termType !== "day" ? "#82b1ff" : "#1c71ff",
                                  border: "none",
                                }}
                              // disabled={termType === "day"}
                              >
                                일간
                              </Button>
                            </ButtonGroup>
                            {termType !== "day" ? (
                              <div className="d-flex flex-row gap-2">
                                <Select
                                  className="mb-0 fs-6"
                                  defaultValue={selectYearRange.find((val) => selectYear === val.value)}
                                  onChange={(val) => setSelectYear(val.value)}
                                  options={selectYearRange}
                                  id={"choices-single-year-range"}
                                ></Select>
                                <Select
                                  className="mb-0 fs-6"
                                  defaultValue={selectMonthRange.find((val) => selectMonth === val.value)}
                                  onChange={(val) => setSelectMonth(val.value)}
                                  options={selectMonthRange}
                                  id={"choices-single-month-range"}
                                ></Select>
                                {/* {termType === "week" ? <Select
                                                        className="mb-0 fs-6"
                                                        defaultValue={selectWeekRange.find((val) => (selectWeek === val.value))}
                                                        onChange={(val) => setSelectWeek(val.value)}
                                                        options={selectWeekRange}
                                                        id={"choices-single-month-range"}
                                                    ></Select> : null} */}
                              </div>
                            ) : (
                              <div className="d-flex flex-row align-items-center gap-2">
                                <Button color="soft" size="sm" onClick={() => moveSelectedDay(-1)}>
                                  1일전
                                </Button>
                                <CommonDatePicker
                                  // id="date-field"
                                  className="form-control"
                                  size={"32px"}
                                  options={{
                                  }}
                                  placeholder="Select Date"
                                  value={startDate}
                                  onChange={(value) => {
                                    selectDailyDate(value[0]);
                                  }}
                                />
                                <Button
                                  color="soft"
                                  size="sm"
                                  disabled={moment(startDate).isSameOrAfter(moment(), "day")}
                                  onClick={() => moveSelectedDay(1)}
                                >
                                  1일후
                                </Button>
                              </div>
                            )}
                            <div>
                              <span className="fs-6 text-muted">{`${startDate} ~ ${endDate}`}</span>
                            </div>
                          </div>
                        );
                      })(),
                    },
                    {
                      id: 3,
                      label: "총매출",
                      // badge: "ri-arrow-up-circle-line text-success",
                      // icon: "ri-space-ship-line",
                      value: (
                        <div>
                          {loadingStatistic ? (
                            <div className="fs-6">
                              <Spinner color="primary"> Loading... </Spinner>
                              <span>데이터를 로딩하는 중입니다...</span>
                            </div>
                          ) : (
                            // <span>{new Intl.NumberFormat().format(siteStatistic["total_amount"])}</span>
                            <div>
                              <div className="mb-4">
                                <span>{new Intl.NumberFormat().format(siteStatistic["total_amount"])}</span>
                              </div>
                              <div className="d-flex flex-row gap-1 ">
                                <Button
                                  
                                  onClick={() => {
                                    setLoadingReceipt(true);
                                    getDataFromUrl(`${BACKEND_HOST}/sites/order-receipt-list/?start_date=${startDate}&end_date=${endDate}`)
                                      .then((data) => {
                                        console.log("sites/order-receipt-list", `?start_date=${startDate}&end_date=${endDate}`, data);
                                        const result_data = export_receipt_data(data["result"]);
                                        openWindowWithTable(result_data);
                                      })
                                      .finally(() => setLoadingReceipt(false));
                                  }}
                                 color="soft">
                                  <i className="ri-printer-line"></i> 내역보기
                                </Button>
                                <Button
                                  
                                  onClick={() => {
                                    setLoadingReceipt(true);
                                    getDataFromUrl(`${BACKEND_HOST}/sites/order-receipt-list/?start_date=${startDate}&end_date=${endDate}`)
                                      .then((data) => {
                                        console.log("sites/order-receipt-list", `?start_date=${startDate}&end_date=${endDate}`, data);
                                        const result_data = export_receipt_data(data["result"]);
                                        const worksheet = utils.json_to_sheet(result_data);
                                        const workbook = utils.book_new();
                                        utils.book_append_sheet(workbook, worksheet, "id");
                                        writeFileXLSX(workbook, "output.xlsx");
                                      })
                                      .finally(() => setLoadingReceipt(false));
                                  }}
                                 color="soft">
                                  <i className="ri-save-2-line"></i> 엑셀파일
                                </Button>
                              </div>
                              {loadingReceipt ? (
                                <div className="pt-3 fs-6">
                                  <Spinner color="primary"> Loading... </Spinner>
                                  <span>로딩중...</span>
                                </div>
                              ) : null}
                            </div>
                          )}
                        </div>
                      ),
                    },
                    // {
                    //     id: 4,
                    //     label: "",
                    //     value:
                    // }
                  ]}
                />
              </Row>
              <Row>
                <Col>
                  {siteStatistics.length ? (
                    <BalanceOverview
                      title={`일별 매출 현황 차트`}
                      start_date={siteStatistics[0]["date"]}
                      end_date={siteStatistics[siteStatistics.length - 1]["date"]}
                      onChange={(value) => {
                        // ${siteStatistics[0]["date"]} - ${siteStatistics[siteStatistics.length - 1]["date"]}
                        getGraphStatistics(value);
                      }}
                      dataList={siteStatistics}
                      initialViewType="preset"
                      initialSelectedRange={1}
                    // viewSelectors={{
                    //   viewType: true,
                    //   dateRange: false,
                    //   showDetails: false,
                    // }}
                    />
                  ) : null}
                </Col>
              </Row>
              <Row>
                <Widgets
                  data={[
                    {
                      id: 1,
                      label: "티켓 주문 건수",
                      // badge: "ri-arrow-up-circle-line text-success",
                      // icon: "ri-space-ship-line",
                      value: (() => {
                        const cancel_count = siteStatistic["statestics_ticket_products"]
                          .map((item) => {
                            return item.canceled_count;
                          })
                          .reduce((sum, currValue) => {
                            return sum + currValue;
                          }, 0);
                        return (
                          <div>
                            <span>
                              {siteStatistic["statestics_ticket_products"]
                                .map((item) => {
                                  return item.ticket_count;
                                })
                                .reduce((sum, currValue) => {
                                  return sum + currValue;
                                }, 0)}
                            </span>
                            {cancel_count ? <span> (-{cancel_count})</span> : null}
                          </div>
                        );
                      })(),
                    },
                    {
                      id: 2,
                      label: "티켓 총매출",
                      // badge: "ri-arrow-up-circle-line text-success",
                      // icon: "ri-space-ship-line",
                      value: new Intl.NumberFormat().format(
                        siteStatistic["statestics_ticket_products"]
                          .map((item) => {
                            return item.ticket_total - item.canceled_total;
                          })
                          .reduce((sum, currValue) => {
                            return sum + currValue;
                          }, 0)
                      ),
                    },
                    // {
                    //     id: 3,
                    //     label: "",
                    //     value: (<div className='d-flex flex-row gap-1 '>
                    //         <Button 
                    //             onClick={() => {
                    //                 getDataFromUrl(`${API_TICKET_ALL}/?order_date=${siteStatistic.date}`).then((data) => {
                    //                     console.log("API_TICKET_ALL", `?order_date=${siteStatistic.date}`, data)
                    //                     const result_data = export_ticket_data(data)
                    //                     openWindowWithTable(result_data)
                    //                 })
                    //             }} color="soft"><i className="ri-printer-line"></i> 내역보기</Button>
                    //         <Button 
                    //             onClick={() => {
                    //                 getDataFromUrl(`${API_TICKET_ALL}/?start_date=${startDate}&end_date=${endDate}`).then((data) => {
                    //                     console.log("API_TICKET_ALL", `?start_date=${startDate}&end_date=${endDate}`, data)
                    //                     const result_data = export_ticket_data(data)
                    //                     const worksheet = utils.json_to_sheet(result_data);
                    //                     const workbook = utils.book_new();
                    //                     utils.book_append_sheet(workbook, worksheet, "id");
                    //                     writeFileXLSX(workbook, "output.xlsx")
                    //                 })
                    //             }} color="soft"><i className="ri-save-2-line"></i> 엑셀파일</Button>
                    //     </div>)
                    // }
                  ]}
                />
              </Row>
              <Row>
                <TicketSalesDetail title={"티켓판매 상세"} data={siteStatistic["statestics_ticket_products"]} />
              </Row>

              <Row>
                <Widgets
                  data={[
                    {
                      id: 1,
                      label: "예약 주문 건수",
                      // badge: "ri-arrow-up-circle-line text-success",
                      // icon: "ri-space-ship-line",
                      value: (() => {
                        const cancel_count = siteStatistic["statestics_pacakge_products"]
                          .map((item) => {
                            return item.canceled_count;
                          })
                          .reduce((sum, currValue) => {
                            return sum + currValue;
                          }, 0);
                        return (
                          <div>
                            <span>
                              {siteStatistic["statestics_pacakge_products"]
                                .map((item) => {
                                  return item.reserv_count;
                                })
                                .reduce((sum, currValue) => {
                                  return sum + currValue;
                                }, 0)}
                            </span>
                            {cancel_count ? <span> (-{cancel_count})</span> : null}
                          </div>
                        );
                      })(),
                    },
                    {
                      id: 2,
                      label: "예약 총매출",
                      // badge: "ri-arrow-up-circle-line text-success",
                      // icon: "ri-space-ship-line",
                      value: new Intl.NumberFormat().format(
                        siteStatistic["statestics_pacakge_products"]
                          .map((item) => {
                            return item.reserv_total + item.option_total - item.canceled_total - item.option_cancel_total;
                          })
                          .reduce((sum, currValue) => {
                            return sum + currValue;
                          }, 0)
                      ),
                    },
                    // {
                    //     id: 3,
                    //     label: "",
                    //     value: (<div className='d-flex flex-row gap-1 '>
                    //         <Button 
                    //             onClick={() => {
                    //                 getDataFromUrl(`${API_RESERVATION_ALL}/?order_date=${siteStatistic.date}`).then((data) => {
                    //                     console.log("API_RESERVATION_ALL", `?order_date=${siteStatistic.date}`, data)
                    //                     const result_data = export_reservation_data(data)
                    //                     openWindowWithTable(result_data)
                    //                 })
                    //             }} color="soft"><i className="ri-printer-line"></i> 내역보기</Button>
                    //             <Button 
                    //             onClick={() => {
                    //                 getDataFromUrl(`${API_RESERVATION_ALL}/?start_date=${startDate}&end_date=${endDate}`).then((data) => {
                    //                     console.log("API_RESERVATION_ALL", `?start_date=${startDate}&end_date=${endDate}`, data)
                    //                     const result_data = export_reservation_data(data)
                    //                     const worksheet = utils.json_to_sheet(result_data);
                    //                     const workbook = utils.book_new();
                    //                     utils.book_append_sheet(workbook, worksheet, "id");
                    //                     writeFileXLSX(workbook, "output.xlsx")
                    //                 })
                    //             }} color="soft"><i className="ri-save-2-line"></i> 엑셀파일</Button>
                    //     </div>)
                    // }
                  ]}
                />
              </Row>
              <Row>
                <PackageSalesDetail title={"예약상품판매 상세"} data={siteStatistic["statestics_pacakge_products"]} />
              </Row>

              {/* <Row>
                            <Widgets data={[
                                {
                                    id: 1,
                                    label: "예약옵션 개별주문 건수",
                                    // badge: "ri-arrow-up-circle-line text-success",
                                    // icon: "ri-space-ship-line",
                                    value: siteStatistic["statestics_option_products"].map((item) => { return item.order_count })
                                        .reduce((sum, currValue) => { return sum + currValue }, 0),
                                },
                                {
                                    id: 2,
                                    label: "예약옵션 개별주문 총매출",
                                    // badge: "ri-arrow-up-circle-line text-success",
                                    // icon: "ri-space-ship-line",
                                    value: new Intl.NumberFormat().format(siteStatistic["statestics_option_products"].map((item) => { return item.order_total - item.canceled_total })
                                        .reduce((sum, currValue) => { return sum + currValue }, 0)),
                                },
                            ]} />
                        </Row>
                        <Row>
                            <TicketSalesDetail title={"예약옵션 개별주문 상세"} data={siteStatistic["statestics_option_products"]} />
                        </Row> */}
            </>
          ) : null}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default SalesStatistics;
